import axios from "./axiosInstance";

export function getInvoiceDeleteConfirmMessage(invoice) {
  const parts = [];
  if (invoice?.invoiceNumber) parts.push(invoice.invoiceNumber);
  if (invoice?.supplierName) parts.push(invoice.supplierName);
  const label = parts.length ? ` (${parts.join(" — ")})` : "";
  return `Delete this invoice${label}? It will be removed from billing and invoice lists.`;
}

export async function deleteInvoiceWithConfirm(invoice) {
  if (!invoice?._id) return false;
  if (!window.confirm(getInvoiceDeleteConfirmMessage(invoice))) return false;
  await axios.post(`/admin/invoices/${invoice._id}/mark-deleted`);
  return true;
}
